import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import api from '../api/client';
import { Button, EmptyState } from '../components/common';
import { TopicDetailsModal } from '../components/modals';
import { formatDate } from '../utils/formatters';

/**
 * ClosedTopics page - View all closed topics for a meeting
 */
const ClosedTopics = ({ meeting, user, onBack }) => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTopic, setSelectedTopic] = useState(null);

  useEffect(() => {
    loadTopics();
  }, [meeting.id]);

  const loadTopics = async () => {
    try {
      const data = await api.get(`/topics/meeting/${meeting.id}`);
      setTopics(data.filter(t => t.closed));
    } catch (error) {
      console.error('Failed to load topics:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-header">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Closed Topics - {meeting.name}</h1>
        <Button variant="secondary" onClick={onBack}>
          ← Back to Meeting
        </Button>
      </div>

      {topics.length === 0 ? (
        <EmptyState
          icon="✓"
          title="No closed topics"
          message="All topics are still open"
        />
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Added By</th>
              <th>Date Added</th>
              <th>Date Closed</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {topics.map(topic => (
              <tr 
                key={topic.id} 
                style={{ cursor: 'pointer' }} 
                onClick={() => setSelectedTopic({ ...topic, meetingName: meeting.name })}
              >
                <td>{topic.title}</td>
                <td>{topic.creatorName}</td>
                <td>{formatDate(topic.createdAt)}</td>
                <td>{topic.closedAt ? formatDate(topic.closedAt) : '-'}</td>
                <td>
                  <span className="badge" style={{ 
                    backgroundColor: 'var(--color-text-muted)', 
                    color: 'white' 
                  }}>
                    Closed
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Topic Details Modal */}
      {selectedTopic && (
        <TopicDetailsModal
          topicId={selectedTopic.id}
          onClose={() => setSelectedTopic(null)}
        />
      )}
    </div>
  );
};

ClosedTopics.propTypes = {
  meeting: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default ClosedTopics;
